import React, { useContext } from 'react';
import { Link, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
// eslint-disable-next-line max-len
import { TwoFactorContext } from 'Services/TwoFactor/Common';
import queryString from 'querystring';
import LoginPage from 'Views/Pages/Login/LoginPage';
import { checkUserDetailsAndShowPopup } from './LoginUtils';

function LoginRoutes() {
	const location = useLocation();
	const navigate = useNavigate();
	const twoFactorMethods = useContext(TwoFactorContext);

	const twoFactorMethodKeys = Object.keys(twoFactorMethods);
	const { redirect, rememberMe } = queryString.parse(location.search.substring(1));

	const onTwoFactorSuccess = () => {
		const redirectString = typeof redirect === 'string' ? redirect : undefined;

		checkUserDetailsAndShowPopup(navigate);

		if (redirectString) {
			navigate(redirectString);
		} else {
			navigate('/');
		}
	};

	return (
		<Routes>
			{/* Routes for each two factor page */}
			{twoFactorMethodKeys.map(x => {
				// eslint-disable-next-line react/destructuring-assignment
				const method = twoFactorMethods[x];
				const onLogin = method.onLogin({
					onTwoFactorSuccess,
					rememberMe: rememberMe === 'true',
				});

				if (onLogin.required) {
					const route = `/2fa/${x.toLocaleLowerCase()}`;
					return <Route key={x} path={route} element={onLogin.content} />;
				}

				return null;
			})}

			{/* Login page route */}
			<Route index element={<LoginPage />} />
		</Routes>
	);
}

export default LoginRoutes;
